import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../api/snackbarSlice';
import { apiClient } from '../../../utils/axios';
import { riskComplianceBasePath } from './riskCompliancePaths';
import { useRiskComplianceErrorMessage } from './useRiskComplianceErrorMessage';

export const useResolveCustomerDunsHandler = (profileId) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const getErrorMessage = useRiskComplianceErrorMessage();

  return useMutation({
    mutationFn: async () => {
      const { data } = await apiClient.post(`${riskComplianceBasePath(profileId)}/resolve`);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['customers', profileId, 'crif', 'risk-compliance'] });
    },
    onError: (error) => {
      dispatch(showSnackbar({ message: getErrorMessage(error), severity: 'error' }));
    },
  });
};
